import {auth, useAuth} from '../use-auth';
import {ReactElement} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {replace} from '@remix-run/router/utils';
import {setInLocalStorage} from '@ui/utils/hooks/local-storage';

interface GuestRouteProps {
  children: ReactElement;
}
export function NotSubscribedRoute({children}: GuestRouteProps) {
  const {isLoggedIn, isSubscribed} = useAuth();

  if (!isLoggedIn) {
    if (typeof window !== 'undefined') {
      const match = window.location.pathname.match(/\/checkout\/([^/]+)\/([^/]+)/);
      if (match) {
        setInLocalStorage('be.onboarding.selected', {
          productId: parseInt(match[1], 10) || match[1],
          priceId: parseInt(match[2], 10) || match[2],
        });
      }
    }
    const search = typeof window !== 'undefined' ? window.location.search : '';
    return <Navigate to={`/register${search ? search : '?redirectFrom=pricing'}`} replace />;
  }

  if (isLoggedIn && isSubscribed) {
    return <Navigate to="/billing" replace />;
  }

  return children || <Outlet />;
}

export function notSubscribedGuard() {
  if (!auth.isLoggedIn) {
    if (typeof window !== 'undefined') {
      const match = window.location.pathname.match(/\/checkout\/([^/]+)\/([^/]+)/);
      if (match) {
        setInLocalStorage('be.onboarding.selected', {
          productId: parseInt(match[1], 10) || match[1],
          priceId: parseInt(match[2], 10) || match[2],
        });
      }
    }
    const search = typeof window !== 'undefined' ? window.location.search : '';
    return replace(`/register${search ? search : '?redirectFrom=pricing'}`);
  }

  return null;
}
